export default "__VITE_ASSET__7647bb2c__"